export const environment = {
  //VERSION: require("package.json").version,
  environment: "dev",
    production: false,
    baseHref: '/dev',
    isMockAPIResponse: false,
   S3BucketName: 'lighting-dev.warnerbros.com',
   recaptcha: {
    siteKey: '6LdzOlMsAAAAAEy72BLrwEQz3tSJdyIy9kOP_dyQ', // Replace with your actual Site Key
  }
  };
  